import mixpanel from '@/plugins/mixpanel'

/**
 * Call after a successful login or registration.
 * Links all past anonymous events to this user and sets their profile.
 */
export function identifyUser(user) {
  // Use _id if available, fall back to email as the stable identifier
  mixpanel.identify(user._id || user.id || user.email)

  mixpanel.people.set({
    $email: user.email,
    $name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
    plan: user.plan,
    auth_provider: user.authProvider,
    created_at: user.createdAt,
    last_login: user.lastLogin,
  })

  // Super properties are merged into every subsequent event automatically
  mixpanel.register({
    is_logged_in: true,
    user_id: user._id || user.id || user.email,
  })
}

/**
 * Call on logout. Marks the session as logged-out then wipes the device identity
 * so the next visitor starts as a fresh anonymous user.
 */
export function resetUser() {
  mixpanel.register({ is_logged_in: false })
  mixpanel.reset()
}
